module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "update-password"
    }
  }, [(!_vm.showConfirmation) ? _c('form', [_c('h2', [_vm._v("Update your Password")]), _vm._v(" "), (_vm.isLoading) ? _c('loader-large') : _vm._e(), _vm._v(" "), (_vm.isSaving) ? _c('saver-large') : _vm._e(), _vm._v(" "), (_vm.keycodeErrors.length > 0) ? _c('div', {
    staticClass: "validation-messages error"
  }, _vm._l((_vm.keycodeErrors), function(error) {
    return _c('span', [_vm._v(_vm._s(error))])
  })) : _vm._e(), _vm._v(" "), (_vm.formErrors.length > 0) ? _c('div', {
    staticClass: "validation-messages error"
  }, _vm._l((_vm.formErrors), function(error) {
    return _c('span', [_vm._v(_vm._s(error))])
  })) : _vm._e(), _vm._v(" "), (!_vm.isLoading && !_vm.isSaving && _vm.keycodeErrors.length === 0) ? [_c('h3', [_vm._v("For " + _vm._s(_vm.recoveryEmail))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPassword),
      expression: "newPassword"
    }],
    attrs: {
      "type": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.newPassword)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.newPassword = $event.target.value
      }, function($event) {
        _vm.formErrors = []
      }]
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPasswordVerify),
      expression: "newPasswordVerify"
    }],
    attrs: {
      "type": "password",
      "placeholder": "Verify Password"
    },
    domProps: {
      "value": (_vm.newPasswordVerify)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.newPasswordVerify = $event.target.value
      }, function($event) {
        _vm.formErrors = []
      }]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "button-container"
  }, [_c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.submitUpdatedPassword($event)
      }
    }
  }, [_vm._v("Update Password")])])] : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.showConfirmation) ? _c('div', {
    staticClass: "confirmation"
  }, [_c('h2', [_vm._v("Your password has been updated!")]), _vm._v(" "), _c('span', [_c('router-link', {
    attrs: {
      "to": "/Login"
    }
  }, [_vm._v("Log In")])], 1)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-090ac0d2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Pages/Login/UpdatePassword.vue
// module id = 817
// module chunks = 2